import DxDataGrid, { DxLoadPanel, DxColumn } from "devextreme-vue/data-grid";
import { DxSpeedDialAction, DxSelectBox } from 'devextreme-vue';

import { workerService } from '../../../services/worker.service';

import notify from 'devextreme/ui/notify'
import moment from 'moment'

export default {
  name: "defaultPlacement",
  data() {
    return {
       workDate : null,
       defaultPlacements: [],
       fcId:this.$store.state.worker.fcId,
       canvas: null,
       context: null,
       image: null,
       file_image: '',
       shiftSubName: '',
       restTimes: [],
       showDefaultPlacement: false,
       showBoard: false,
       showShift: false,
    };
  },
  methods: {
    fetchDefaultPlacementData(fcId) {

      let self = this;

      // 初期配置／ボード情報の表示判定
      workerService.checkPlacement(fcId)
        .then(
          async success => {
            
            // 初期配置／ボード情報／シフト情報の表示フラグ設定
            self.showDefaultPlacement = false;
            self.showBoard = false;
            self.showShift = false;
            
            if (success.messageType == 1) {
              // 初期配置／ボード情報の表示判定が取得できた場合
              switch (success.content) {
                case 2: //初期配置のみ表示
                  self.showDefaultPlacement = true;
                  break;
                case 3: //ボード情報のみ表示
                  self.showBoard = true;
                  break;
                case 4: //初期配置/ボード情報を両方表示
                  self.showDefaultPlacement = true;
                  self.showBoard = true;
                  break;
              }
              
              let errorFlag = false;
              let existDataFlag = false;
              let noDataMsg = success.message;

              if (self.showDefaultPlacement || self.showBoard) {

                // 初期配置が表示ONの場合、初期配置情報を取得
                if (self.showDefaultPlacement) {
                  await workerService.getDefaultPlacement(fcId)
                    .then(
                      success => {
                        if (success.messageType == 1) {
                          self.defaultPlacements = success.content.defaultPlacements;
                          self.workDate = moment(success.content.workDate).format('M月D日');
                          existDataFlag = true;
                        } else {
                          console.log(success.message);
                          noDataMsg = success.message;
                          self.showDefaultPlacement = false;
                        }
                      },
                      error => {
                        console.log(error);
                        errorFlag = true;
                      }
                    );

                  if (errorFlag) return;  //エラーの場合、処理終了
                }
                
                // ボード情報が表示ONの場合、ボード情報を取得
                if (self.showBoard) {
                  await workerService.getDigitalMagnet(fcId)
                    .then(
                      success => {
                        if (success.messageType == 1) {
                          //canvasからボード情報の画像を生成
                          self.createBoardImage(success.content);
                          existDataFlag = true;
                        } else {
                          console.log(success.message);
                          noDataMsg = success.message;
                          self.showBoard = false;
                        }
                      },
                      error => {
                        console.log(error);
                        errorFlag = true;
                      }
                    );

                  if (errorFlag) return;  //エラーの場合、処理終了
                }
                
                if (existDataFlag) {
                  // 休憩時間情報を取得
                  await workerService.getShift(fcId)
                    .then(
                      success => {
                        if (success.messageType == 1) {

                          switch (success.content.shiftDisplayType) {
                            case '0': // シフト表示設定が「表示しない」の場合
                              self.showShift = false;
                              self.shiftSubName = '';
                              self.restTimes = [];
                              break;
                            case '1': // シフト表示設定が「詳細シフトのみ表示」の場合
                              self.showShift = true;
                              self.shiftSubName = success.content.shiftSubName;
                              self.restTimes = [];
                              break;
                            case '2': // シフト表示設定が「詳細シフト+休憩時間を表示」の場合
                              self.showShift = true;
                              self.shiftSubName = success.content.shiftSubName;
                              self.restTimes = success.content.restTimes;
                              break;
                          }
                        } else {
                          console.log(success.message);
                          self.showShift = false;
                        }
                      },
                      error => {
                        console.log(error);
                        errorFlag = true;
                      }
                    );

                  if (errorFlag) return;  //エラーの場合、処理終了
                }
              }

              if (!existDataFlag) {
                // 「該当データなし」の場合
                self.showMessage(noDataMsg, 'error');

                // ホーム画面に戻る
                this.$router.push({
                  name: 'home'
                })
              }

            } else {
              // 「汎用マスタ設定不正」の場合
              self.showMessage(success.message, 'error');

              // ホーム画面に戻る
              this.$router.push({
                name: 'home'
              })
            }
          },
          error => {
            console.log(error)
          }
        );
    },
    createBoardImage(boardData) {

      let self = this;

      // canvasを取得
      this.canvas = this.$refs.placedCanvas;
      this.context = this.canvas.getContext("2d");

      // canvasをクリア
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.beginPath();

      // canvasに背景画像を描画
      // ※drawImageは、Imageのsrcが読み込み終わってからでないと描画されないため、onloadイベントで実行する。
      this.image = new Image();
      this.image.src = "data:image/jpeg;base64," + boardData.image;
      this.image.onload = function() {
        self.context.drawImage(self.image, 0, 0, self.canvas.width, self.canvas.height);

        // canvasに初期配置の印●を描画
        // ※印●はマグネットの中心に描画する。
        self.context.shadowOffsetX = 2;
        self.context.shadowOffsetY = 2;
        self.context.shadowBlur = 4;
        self.context.shadowColor = "rgba(50, 50, 50, 0.7)";
        self.context.fillStyle = "red";
        let postionX = boardData.positionX;
        let postionY = boardData.positionY;
        switch (boardData.magnetTypeId) {
          case 1: //SmallWide横長(サイズ116x54)
            postionX += 116 / 2;
            postionY += 54 / 2;
            break;
          case 2: //Small縦長(サイズ54x116)
            postionX += 54 / 2;
            postionY += 116 / 2;
            break;
          case 3: //Medium(サイズ100x120)
            postionX += 100 / 2;
            postionY += 120 / 2;
            break;
          case 4: //MiniWide(サイズ74x28)
            postionX += 74 / 2;
            postionY += 28 / 2;
            break;     
          case 5: //Mini(サイズ36x74)
            postionX += 36 / 2;
            postionY += 74 / 2;
            break;        
          case 6: //NotImg(サイズ74x28)
            postionX += 74 / 2;
            postionY += 28 / 2;
            break;        
          case 7: //SpindlyWide(サイズ116x28)
            postionX += 116 / 2;
            postionY += 28 / 2;
            break;
          
          default: //デフォルトはSmallWide(サイズ116x54)
            postionX += 116 / 2;
            postionY += 54 / 2;
            break;
        }
        self.context.arc(postionX, postionY, 20, 0, 2*Math.PI, false);
        self.context.fill();

        // 影なしに戻す
        self.context.shadowOffsetX = 0;
        self.context.shadowOffsetY = 0;
        self.context.shadowBlur = 0;

        // 印●の枠を描画する
        self.context.shadowColor = "gray";
        self.context.strokeStyle = "black";
        self.context.stroke();

        // imgタグにcanvasから生成した画像(base64形式)を設定
        self.file_image = self.canvas.toDataURL("image/jpeg");
      };
      
    },
    digiBoImg_OnClick: function (){
      let openWindow = window.open();
      openWindow.document.open();
      openWindow.document.write("<div><img src='" + this.file_image +"'></img></div>");
      openWindow.document.close();
      openWindow.document.title = '現在のボード情報';
    },
    onClickRefreshData() {
      this.fetchDefaultPlacementData(this.fcId);
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  }, 
  mounted() {
    this.fetchDefaultPlacementData(this.fcId);
  },
  watch: {
    '$route': function(){
      this.fetchDefaultPlacementData(this.fcId)
    }
    
  },
  components: {
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxSpeedDialAction,
    DxSelectBox,
    moment
  }
};